import { render, staticRenderFns } from "./chats.vue?vue&type=template&id=26f02afa&scoped=true"
import script from "./chats.vue?vue&type=script&lang=js"
export * from "./chats.vue?vue&type=script&lang=js"
import style0 from "./chats.vue?vue&type=style&index=0&id=26f02afa&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f02afa",
  null
  
)

export default component.exports